import React from "react";
import styled from "styled-components";

const Title = styled.div`
  font-family: "Montserrat";
  font-weight: 600;
  line-height: 20px;
  color: #181122;
  text-transform: uppercase;
  width: 100%;
`;

const Line = styled.div`
  border: none;
  height: 10px;
  border-bottom: 2px solid #57c4c2;
  width: 96px;
`;

export default function BasicTitle({ title, margin, showLine = true, center = false, fontSize = 14 }) {
  return (
    <Title
      style={{
        fontSize: fontSize,
        marginBottom: margin ?? 16,
        textAlign: center ? "center" : "left",
      }}
    >
      {title}
      {showLine && <Line />}
    </Title>
  );
}
